/**
 * Configured Day.js (plugins + default export). This is the only module that imports
 * the `dayjs` package. Prefer `helpers/date/dateHelpers` for common operations; import
 * from here when you need the full API (e.g. `order_times`, store transforms).
 */
import dayjs, { type Dayjs } from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

/**
 * Register plugins once (utc before timezone; parsing plugins before use).
 */
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isBetween);

/** Configured date factory (currently Day.js); swap implementation by editing this file only. */
const dateCore = dayjs;

export default dateCore;
export type DateCore = Dayjs;
